import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember, TypedJSON} from 'typedjson';

import {ConnectionState} from '@/model/network/connection/ConnectionState';
import {ConnectionType} from '@/model/network/connection/ConnectionType';
import {Ip4Status, Ip6Status, IpStatus} from '@/model/network/connection/IpStatus';
import {Dhcp4Status} from '@/model/network/connection/Dhcp4Status';
import {Dhcp6Status} from '@/model/network/connection/Dhcp6Status';
import {ProfileSettings} from '@/model/network/settings/ProfileSettings';

@jsonObject
export class Connection {

  public static get Serializer(): TypedJSON<Connection> {
    if (!Connection.serializer) {
      Connection.serializer = new TypedJSON(Connection);
    }

    return Connection.serializer;
  }

  private static serializer: TypedJSON<Connection> | undefined;

  @jsonMember({name: 'id'})
  public Id!: string;

  @jsonMember({name: 'uuid'})
  public UUID!: string;

  @jsonMember({name: 'type', constructor: String})
  public Type!: ConnectionType;

  @jsonMember({name: 'state', constructor: String})
  public State!: ConnectionState;

  @jsonMember({name: 'isMaster'})
  public IsMaster!: boolean;

  @jsonMember({name: 'isSlave'})
  public IsSlave!: boolean;

  @jsonMember({name: 'layer2Ready'})
  public Layer2Ready!: boolean;

  @jsonMember({name: 'ip4Ready'})
  public Ip4Ready!: boolean;

  @jsonMember({name: 'ip6Ready'})
  public Ip6Ready!: boolean;

  @jsonMember({name: 'masterHasSlaves'})
  public MasterHasSlaves!: boolean;

  @jsonMember({name: 'lifetimeBoundToProfileVisibility'})
  public LifetimeBoundToProfileVisibility!: boolean;

  @jsonMember({name: 'default'})
  public Default!: boolean;

  @jsonMember({name: 'ip4Config', constructor: Ip4Status})
  public IP4Config!: IpStatus;

  @jsonMember({name: 'dhcp4Config'})
  public DHCP4Config!: Dhcp4Status;

  @jsonMember({name: 'default6'})
  public Default6!: boolean;

  @jsonMember({name: 'ip6Config', constructor: Ip6Status})
  public IP6Config!: IpStatus;

  @jsonMember({name: 'dhcp6Config'})
  public DHCP6Config!: Dhcp6Status;

  @jsonMember({name: 'vpn'})
  public VPN!: boolean;

  @jsonMember({name: 'profile'})
  public ProfileId!: string;

  @jsonArrayMember(String, {name: 'devices'})
  public DevicesId!: string[];

// public MasterDevice: Device;

}
